import { render, staticRenderFns } from "./InheritComp.vue?vue&type=template&id=7887a412&scoped=true&lang=pug&"
import script from "./InheritComp.vue?vue&type=script&lang=js&"
export * from "./InheritComp.vue?vue&type=script&lang=js&"
import style0 from "./InheritComp.vue?vue&type=style&index=0&id=7887a412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7887a412",
  null
  
)

export default component.exports